import { render, staticRenderFns } from "./CSRecievedRequests.vue?vue&type=template&id=643f516c&"
import script from "./CSRecievedRequests.vue?vue&type=script&lang=js&"
export * from "./CSRecievedRequests.vue?vue&type=script&lang=js&"
import style0 from "./CSRecievedRequests.vue?vue&type=style&index=0&id=643f516c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports